import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

import {
  ACCOMONDATION,
  FACILITIES,
  SCORE,
  SORTING_OPTIONS,
  STARS,
} from 'src/app/shared/used-components/hotels-booking-container/utils';

import { HotelsBookingProviderService } from 'src/app/shared/used-components/hotels-booking-container/hotels-booking-provider.service';

import { HotelPriceRangePanelComponent } from 'src/app/shared/used-components/hotels-booking-container/hotel-price-range-panel/hotel-price-range-panel.component';

@Component({
  selector: 'app-hotel-filters-mobile',
  templateUrl: './hotel-filters-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButton,
    MatCheckbox,
    FormsModule,
    MatRadioGroup,
    MatRadioButton,
    HotelPriceRangePanelComponent,
  ],
  providers: [HotelsBookingProviderService],
})
export class HotelFiltersMobileComponent implements OnChanges {
  @Input() filters: Record<string, any> = {
    facilities: [],
    stars: [],
    score: null,
    accomondation: [],
    priceRange: {
      min: null,
      max: null,
    },
    sorting: null,
    refundable: false,
    breakfastIncluded: false,
  };

  @Output() onApply = new EventEmitter<{
    requestBody: Record<string, any>;
    filters: Record<string, any>;
  }>();
  facilitiesOptions = FACILITIES;
  starsOptions = STARS;
  scoreOptions = SCORE;
  accomondationOptions = ACCOMONDATION;
  sortingOptions = SORTING_OPTIONS;

  selectedFilters: any = {
    facilities: [],
    stars: [],
    score: null,
    accomondation: [],
    priceRange: {
      min: null,
      max: null,
    },
    sorting: null,
    refundable: false,
    breakfastIncluded: false,
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.filters.currentValue) {
        this.selectedFilters = this.filters;
      }
    }
  }

  applyFilters(): void {
    this.onApply.emit({
      requestBody: this.selectedFilters,
      filters: this.selectedFilters,
    });
  }

  onChangeArray(event: any, arrayName: string, value: any): void {
    if (event.checked) {
      this.selectedFilters[arrayName].push(value);
    } else {
      this.selectedFilters[arrayName] = this.selectedFilters[arrayName].filter(
        (star) => star !== value,
      );
    }
  }

  clearFilters(): void {
    this.selectedFilters = {
      facilities: [],
      stars: [],
      score: null,
      accomondation: [],
      priceRange: {
        min: null,
        max: null,
      },
      sorting: null,
      refundable: false,
      breakfastIncluded: false,
    };
  }

  priceChangeHandler({ min, max }: { min: number; max: number }): void {
    this.selectedFilters.priceRange.min = min;
    this.selectedFilters.priceRange.max = max;
  }
}
